import type { FC } from "react";

import { UiUploadIcon } from "@jti/brand-icons/ui-upload";

import styles from "./Invoice.module.scss";

type InvoiceProps = {
  url?: string;
  label?: string;
};

export const Invoice: FC<InvoiceProps> = ({ url, label }) => {
  if (!url) return null;

  return (
    <div className={styles.wrapper}>
      <a className={styles.anchor} href={url} target="_blank" rel="noreferrer">
        <UiUploadIcon className={styles.icon} />
        <span className={styles.label}>{label}</span>
      </a>
    </div>
  );
};
